import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
    sendAsset: string;
    curculateKrw: string;
    trxBalance: string;
    selectedAsset?: ViewModel.IAsset;
    fee: number;
}

const SendTransactionAmountInfo = ({sendAsset, curculateKrw, selectedAsset, trxBalance, fee}: IProps) => {
    return (
        <div className="content">
        <div className="amount-details">
            <div className="detail">
                <span className="body-s-n">보낼 수량:</span>
                <div className="amount-group">
                    <span className="amount body-n-n d-gray">{sendAsset} {selectedAsset?.symbol}</span>
                    <span className="krw body-xs-n d-gray">{curculateKrw} 원</span>
                </div>
            </div>
            <div className="detail">
                <span className="body-s-n">예상 수수료:</span>
                <div className="amount-group">
                    <span className="amount body-n-n d-gray">{fee} TRX</span>
                    <span className="balance body-xs-n d-gray">잔액: {trxBalance} TRX</span>
                </div>
            </div>
            <div className="total">
                <span className="body-s-n">합계:</span>
                <div className="amount-group">
                    <span className="total-amount body-n-n d-gray">{Number((Number(sendAsset)).toFixed(6))} {selectedAsset?.symbol}</span>
                    <span className="total-fee body-n-n d-gray">{fee} TRX</span>
                </div>
            </div>
            </div>
        </div>
    )
}

export default SendTransactionAmountInfo    